/* ===== KP SHOES - JS personnalise ===== */

/* Selecteur de taille : onglets EU/US/UK/CM (sneakers), prix par taille, tri des tailles vetements */
(function () {
  var US_TABLES = {
    standard: {
      3550: 3.5, 3600: 4, 3650: 4.5, 3700: 4.5, 3750: 5, 3800: 5.5,
      3850: 6, 3900: 6.5, 3950: 6.5, 4000: 7, 4050: 7.5, 4100: 8,
      4150: 8, 4200: 8.5, 4250: 9, 4300: 9.5, 4350: 9.5, 4400: 10,
      4450: 10.5, 4500: 11, 4550: 11.5, 4600: 12, 4650: 12, 4700: 12.5,
      4750: 13, 4800: 13.5, 4850: 14, 4900: 14.5, 4950: 15, 5000: 15.5,
      5050: 16, 5100: 16.5, 5150: 17, 5200: 17.5, 5250: 18
    },
    adidas: {
      3550: 3.5, 3600: 4, 3667: 4.5, 3733: 5, 3800: 5.5, 3867: 6,
      3933: 6.5, 4000: 7, 4067: 7.5, 4133: 8, 4200: 8.5, 4267: 9,
      4333: 9.5, 4400: 10, 4467: 10.5, 4533: 11, 4600: 11.5, 4667: 12,
      4733: 12.5
    },
    slide: {
      3600: 3, 3700: 4, 3800: 5, 3900: 6, 4050: 7, 4200: 8,
      4300: 9, 4450: 10, 4600: 11, 4700: 12, 4850: 13, 5000: 14,
      5100: 15, 5200: 16
    }
  };

  /* Longueur du pied en cm, a partir de la taille US homme */
  var CM_TABLES = {
    standard: {
      3.5: 22.5, 4: 23, 4.5: 23.5, 5: 23.5, 5.5: 24, 6: 24, 6.5: 24.5,
      7: 25, 7.5: 25.5, 8: 26, 8.5: 26.5, 9: 27, 9.5: 27.5, 10: 28,
      10.5: 28.5, 11: 29, 11.5: 29.5, 12: 30, 12.5: 30.5, 13: 31,
      13.5: 31.5, 14: 32, 14.5: 32.5, 15: 33, 15.5: 33.5, 16: 34,
      16.5: 34.5, 17: 35, 17.5: 35.5, 18: 36
    },
    adidas: {
      3.5: 21.7, 4: 22.1, 4.5: 22.5, 5: 22.9, 5.5: 23.3, 6: 23.8,
      6.5: 24.2, 7: 24.6, 7.5: 25, 8: 25.5, 8.5: 25.9, 9: 26.3,
      9.5: 26.7, 10: 27.1, 10.5: 27.6, 11: 28, 11.5: 28.4, 12: 28.8,
      12.5: 29.3
    }
  };

  /* Ordre des tailles vetements */
  var APPAREL_ORDER = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', 'TU', 'TAILLE UNIQUE', 'ONE SIZE', 'OS'];

  var unit = 'EU';
  try { unit = localStorage.getItem('kp-size-unit') || 'EU'; } catch (e) {}

  var productCache = {};

  function brand() {
    var og = document.querySelector('meta[property="og:title"]');
    var t = ((og && og.content) || document.title || '').toLowerCase();
    if (t.indexOf('yeezy slide') !== -1) return 'slide';
    if (t.indexOf('adidas') !== -1 || t.indexOf('yeezy') !== -1) return 'adidas';
    return 'standard';
  }

  function units() {
    return CM_TABLES[brand()] ? ['EU', 'US', 'UK', 'CM'] : ['EU', 'US', 'UK'];
  }

  function parseEu(str) {
    var s = String(str || '').replace(/EU|Y|GS/gi, '').replace(',', '.').trim();
    var f = s.match(/^(\d+)\s+(\d+)\/(\d+)$/);
    if (f) return parseInt(f[1], 10) + parseInt(f[2], 10) / parseInt(f[3], 10);
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function euToUs(eu) {
    var table = US_TABLES[brand()];
    var key = Math.round(eu * 100);
    if (table.hasOwnProperty(key)) return table[key];
    var best = null, dist = Infinity;
    for (var k in table) {
      var d = Math.abs(parseInt(k, 10) - key);
      if (d < dist) { dist = d; best = k; }
    }
    return dist <= 50 ? table[best] : null;
  }

  function convert(euLabel, target) {
    if (target === 'EU') return euLabel;
    var n = parseEu(euLabel);
    if (n == null) return euLabel;
    var us = euToUs(n);
    if (us == null) return euLabel;
    var b = brand();
    if (target === 'US') return String(us);
    if (target === 'UK') {
      if (b === 'adidas' || b === 'slide') return String(us - 0.5);
      return String(us < 7 ? us - 0.5 : us - 1);
    }
    if (target === 'CM') {
      var cm = CM_TABLES[b] && CM_TABLES[b][us];
      return cm ? String(cm) : euLabel;
    }
    return euLabel;
  }

  function isShoeSize(values) {
    if (!values.length) return false;
    return values.every(function (v) {
      var n = parseEu(v);
      return n != null && n >= 30 && n <= 55;
    });
  }

  function apparelRank(v) {
    return APPAREL_ORDER.indexOf(String(v || '').trim().toUpperCase());
  }

  function isApparelSize(values) {
    if (!values.length) return false;
    return values.every(function (v) { return apparelRank(v) !== -1; });
  }

  function sortApparel(options) {
    if (!options.length) return;
    var list = options[0].parentNode;
    var current = Array.prototype.slice.call(options);
    var sorted = current.slice().sort(function (a, b) {
      return apparelRank(a.dataset.kpValue) - apparelRank(b.dataset.kpValue);
    });
    var same = sorted.every(function (el, i) { return el === current[i]; });
    if (same) return;
    sorted.forEach(function (el) { list.appendChild(el); });
  }

  function formatMoney(cents) {
    var v = cents / 100;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: v % 1 === 0 ? 0 : 2
    }).format(v);
  }

  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function priceData(variant) {
    if (!variant) return null;
    if (!variant.available) {
      return { cls: 'kp-opt-price kp-opt-price--out', text: 'Épuisé', compare: '' };
    }
    var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
    return {
      cls: 'kp-opt-price',
      text: formatMoney(variant.price),
      compare: sale ? formatMoney(variant.compare_at_price) : ''
    };
  }

  function setPrice(container, data, before) {
    var el = container.querySelector(':scope > .kp-opt-price');
    if (!data) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('span');
      container.insertBefore(el, before || null);
    }

    var key = data.cls + '|' + data.text + '|' + data.compare;
    if (el.dataset.key === key) return;
    el.dataset.key = key;
    el.className = data.cls;
    el.textContent = '';

    if (data.compare) {
      var old = document.createElement('s');
      old.className = 'kp-opt-compare';
      old.textContent = data.compare;
      el.appendChild(old);
    }

    var current = document.createElement('span');
    current.textContent = data.text;
    el.appendChild(current);
  }

  function apply() {
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var handle = picker.getAttribute('handle');

      picker.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
        var options = fieldset.querySelectorAll('.popover__value-option');
        var button = fieldset.querySelector('button.select');
        if (!options.length || !button) return;

        var spans = [];
        options.forEach(function (opt) {
          var sp = opt.querySelector(':scope > span:not(.kp-opt-price)');
          if (!sp) return;
          if (!sp.dataset.kpEu) sp.dataset.kpEu = sp.textContent.trim();
          if (!opt.dataset.kpValue) opt.dataset.kpValue = sp.dataset.kpEu;
          spans.push(sp);
        });

        var values = spans.map(function (sp) { return sp.dataset.kpEu; });
        var shoes = isShoeSize(values);
        var apparel = !shoes && isApparelSize(values);
        if (!shoes && !apparel) return;

        fieldset.classList.add('kp-size-picker');
        fieldset.classList.add(shoes ? 'kp-size-picker--shoes' : 'kp-size-picker--apparel');
        var popover = fieldset.querySelector('x-popover');
        if (popover) popover.classList.add('kp-size-popover');

        var activeUnit = 'EU';

        if (shoes) {
          /* Onglets EU / US / UK / CM */
          var info = fieldset.querySelector('.variant-picker__option-info');
          if (info && !info.querySelector('.kp-size-units')) {
            var tabs = document.createElement('div');
            tabs.className = 'kp-size-units';
            units().forEach(function (u) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'kp-size-units__btn';
              b.dataset.unit = u;
              b.textContent = u;
              tabs.appendChild(b);
            });
            info.insertBefore(tabs, info.firstChild);
          }

          activeUnit = units().indexOf(unit) === -1 ? 'EU' : unit;
          fieldset.querySelectorAll('.kp-size-units__btn').forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.unit === activeUnit);
          });

          spans.forEach(function (sp) {
            var next = convert(sp.dataset.kpEu, activeUnit);
            if (sp.textContent !== next) sp.textContent = next;
          });
        } else {
          /* Vetements : tailles dans l'ordre XS, S, M, L, XL... */
          sortApparel(options);
        }

        /* Libelle de la taille choisie dans le bouton */
        var checked = fieldset.querySelector('.popover__value-option input:checked');
        var checkedSpan = checked && checked.parentNode.querySelector(':scope > span:not(.kp-opt-price)');
        var selected = button.querySelector('span[id$="-selected-value"]');
        if (selected && checkedSpan) {
          var label = convert(checkedSpan.dataset.kpEu, activeUnit);
          if (selected.textContent !== label) selected.textContent = label;
        }

        /* Prix par taille */
        if (!handle) return;
        loadProduct(handle).then(function (product) {
          if (!product || product.options.length > 1) return;
          var byValue = {};
          product.variants.forEach(function (v) { byValue[v.option1] = v; });

          options.forEach(function (opt) {
            var sp = opt.querySelector(':scope > span:not(.kp-opt-price)');
            if (sp) setPrice(opt, priceData(byValue[sp.dataset.kpEu]));
          });

          if (checkedSpan) {
            setPrice(button, priceData(byValue[checkedSpan.dataset.kpEu]), button.querySelector('svg'));
          }
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.kp-size-units__btn');
    if (tab) {
      unit = tab.dataset.unit;
      try { localStorage.setItem('kp-size-unit', unit); } catch (err) {}
      apply();
    }
  });

  function init() {
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* SKU : affiche uniquement la reference, sans "SKU:" */
(function () {
  function cleanSku() {
    document.querySelectorAll('variant-sku').forEach(function (el) {
      var text = el.textContent.replace(/^\s*SKU\s*:\s*/i, '');
      if (text !== el.textContent) el.textContent = text;
    });
  }

  function init() {
    cleanSku();
    new MutationObserver(cleanSku).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Panier (drawer) : prix avant reduction barre en rouge */
(function () {
  var cache = {};

  function loadProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: cents % 100 ? 2 : 0,
      maximumFractionDigits: 2
    }).replace(/\s/g, '') + '€';
  }

  function apply() {
    document.querySelectorAll('line-item').forEach(function (line) {
      var price = line.querySelector('.line-item__line-price');
      var link = line.querySelector('a[href*="/products/"]');
      if (!price || !link) return;

      var url = new URL(link.getAttribute('href'), location.origin);
      var match = url.pathname.match(/\/products\/([^\/?#]+)/);
      var variantId = url.searchParams.get('variant');
      if (!match || !variantId) return;

      var qtyInput = line.querySelector('input[name="updates[]"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      loadProduct(match[1]).then(function (product) {
        if (!product) return;
        var variant = product.variants.find(function (v) { return String(v.id) === variantId; });
        var el = price.parentNode.querySelector(':scope > .kp-line-compare');
        var text = (variant && variant.compare_at_price > variant.price)
          ? formatMoney(variant.compare_at_price * qty)
          : '';

        if (!text) {
          if (el) el.remove();
          return;
        }
        if (!el) {
          el = document.createElement('s');
          el.className = 'kp-line-compare';
          price.parentNode.insertBefore(el, price);
        }
        if (el.textContent !== text) el.textContent = text;
      });
    });
  }

  function init() {
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Panier (drawer) : pastille de livraison selon le stock */
(function () {
  var modes = {};
  var pending = false;

  var LABELS = {
    express: { cls: 'kp-delivery kp-delivery--express', text: 'Livraison express 48h' },
    standard: { cls: 'kp-delivery kp-delivery--standard', text: 'Livraison 5 à 10 jours ouvrés' },
    preorder: { cls: 'kp-delivery kp-delivery--preorder', text: 'Précommande' }
  };

  function variantIdOf(line) {
    var link = line.querySelector('a[href*="variant="]');
    if (!link) return null;
    return new URL(link.getAttribute('href'), location.origin).searchParams.get('variant');
  }

  function fetchModes() {
    if (pending) return;
    pending = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + '?sections=kp-cart-delivery')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['kp-cart-delivery'] || '';
        var match = html.match(/<script[^>]*data-kp-delivery[^>]*>([\s\S]*?)<\/script>/);
        var map = match ? JSON.parse(match[1]) : {};
        Object.keys(map).forEach(function (id) { modes[id] = map[id]; });
      })
      .catch(function () {})
      .then(function () {
        pending = false;
        render(true);
      });
  }

  function render(afterFetch) {
    var missing = false;

    document.querySelectorAll('line-item').forEach(function (line) {
      var id = variantIdOf(line);
      if (!id) return;

      if (!modes.hasOwnProperty(id)) {
        if (afterFetch) modes[id] = 'none';
        else missing = true;
        return;
      }

      var badge = line.querySelector('.kp-delivery');
      var label = LABELS[modes[id]];
      if (!label) {
        if (badge) badge.remove();
        return;
      }

      var anchor = line.querySelector('.line-item__quantity-selector');
      if (!anchor) return;

      if (!badge) {
        badge = document.createElement('p');
        anchor.parentNode.insertBefore(badge, anchor.nextSibling);
      }
      if (badge.className !== label.cls) badge.className = label.cls;
      if (badge.textContent !== label.text) badge.textContent = label.text;
    });

    if (missing) fetchModes();
  }

  function init() {
    render(false);
    new MutationObserver(function () { render(false); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Collections : fleches sur la navigation rapide */
(function () {
  var ARROW = '<svg width="15" height="12" viewBox="0 0 15 12" aria-hidden="true"><path d="M0 6h13.5M8.5 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';

  function update(wrap) {
    var list = wrap.querySelector('.collection-quick-navigation');
    var max = list.scrollWidth - list.clientWidth;
    var atStart = list.scrollLeft <= 2;
    var atEnd = list.scrollLeft >= max - 2;

    wrap.classList.toggle('kp-qnav--scrollable', max > 2);
    wrap.classList.toggle('kp-qnav--fade-left', max > 2 && !atStart);
    wrap.classList.toggle('kp-qnav--fade-right', max > 2 && !atEnd);
    wrap.querySelector('.kp-qnav__btn--prev').disabled = atStart;
    wrap.querySelector('.kp-qnav__btn--next').disabled = atEnd;
  }

  function setup(list) {
    if (list.parentElement.classList.contains('kp-qnav')) return;

    var wrap = document.createElement('div');
    wrap.className = 'kp-qnav';
    list.parentNode.insertBefore(wrap, list);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'kp-qnav__btn kp-qnav__btn--prev';
    prev.setAttribute('aria-label', 'Précédent');
    prev.innerHTML = ARROW;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'kp-qnav__btn kp-qnav__btn--next';
    next.setAttribute('aria-label', 'Suivant');
    next.innerHTML = ARROW;

    wrap.appendChild(prev);
    wrap.appendChild(list);
    wrap.appendChild(next);

    prev.addEventListener('click', function () {
      list.scrollBy({ left: -list.clientWidth * 0.7, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      list.scrollBy({ left: list.clientWidth * 0.7, behavior: 'smooth' });
    });
    list.addEventListener('scroll', function () { update(wrap); }, { passive: true });
    window.addEventListener('resize', function () { update(wrap); });

    var selected = list.querySelector('.is-selected');
    if (selected) {
      list.scrollLeft += selected.getBoundingClientRect().left - list.getBoundingClientRect().left
        - (list.clientWidth - selected.offsetWidth) / 2;
    }
    update(wrap);
  }

  function init() {
    document.querySelectorAll('.collection-quick-navigation').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();